"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGiftInvitationTemplatesEntities = exports.getGiftInvitationTemplatesNames = exports.getGiftInvitationTemplatesByName = exports.getGiftInvitationTemplatesAll = exports.getIsGiftInvitationTemplatesRejected = exports.getIsGiftInvitationTemplatesFulfilled = exports.getIsGiftInvitationTemplatesPending = exports.getIsGiftInvitationTemplatesIdle = exports.getGiftInvitationTemplateId = void 0;

var _ramda = require("ramda");

var _utils = require("@alycecom/utils");

var _giftInvitationTemplates = require("./giftInvitationTemplates.reducer");

var getGiftInvitationTemplatesState = function getGiftInvitationTemplatesState(state) {
  return state.modules.campaignSettings.entities.giftInvitationTemplates;
};

var selectors = _giftInvitationTemplates.giftInvitationTemplatesAdapter.getSelectors(getGiftInvitationTemplatesState);

var getGiftInvitationTemplateId = (0, _ramda.pipe)(getGiftInvitationTemplatesState, (0, _ramda.prop)('giftInvitationTemplateId'));
exports.getGiftInvitationTemplateId = getGiftInvitationTemplateId;
var getGiftInvitationTemplatesStatus = (0, _ramda.pipe)(getGiftInvitationTemplatesState, (0, _ramda.prop)('status'));
var getIsGiftInvitationTemplatesIdle = (0, _ramda.pipe)(getGiftInvitationTemplatesStatus, (0, _ramda.equals)(_utils.StateStatus.Idle));
exports.getIsGiftInvitationTemplatesIdle = getIsGiftInvitationTemplatesIdle;
var getIsGiftInvitationTemplatesPending = (0, _ramda.pipe)(getGiftInvitationTemplatesStatus, (0, _ramda.equals)(_utils.StateStatus.Pending));
exports.getIsGiftInvitationTemplatesPending = getIsGiftInvitationTemplatesPending;
var getIsGiftInvitationTemplatesFulfilled = (0, _ramda.pipe)(getGiftInvitationTemplatesStatus, (0, _ramda.equals)(_utils.StateStatus.Fulfilled));
exports.getIsGiftInvitationTemplatesFulfilled = getIsGiftInvitationTemplatesFulfilled;
var getIsGiftInvitationTemplatesRejected = (0, _ramda.pipe)(getGiftInvitationTemplatesStatus, (0, _ramda.equals)(_utils.StateStatus.Rejected));
exports.getIsGiftInvitationTemplatesRejected = getIsGiftInvitationTemplatesRejected;
var getGiftInvitationTemplatesAll = selectors.getAll,
    getGiftInvitationTemplatesByName = selectors.getById,
    getGiftInvitationTemplatesNames = selectors.getIds,
    getGiftInvitationTemplatesEntities = selectors.getEntities;
exports.getGiftInvitationTemplatesEntities = getGiftInvitationTemplatesEntities;
exports.getGiftInvitationTemplatesNames = getGiftInvitationTemplatesNames;
exports.getGiftInvitationTemplatesByName = getGiftInvitationTemplatesByName;
exports.getGiftInvitationTemplatesAll = getGiftInvitationTemplatesAll;